import { render, staticRenderFns } from "./AssessmentSidePanel.vue?vue&type=template&id=7028973e"
import script from "./AssessmentSidePanel.vue?vue&type=script&lang=js"
export * from "./AssessmentSidePanel.vue?vue&type=script&lang=js"
import style0 from "./AssessmentSidePanel.vue?vue&type=style&index=0&id=7028973e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports